import './App.css';
import { Provider } from 'react-redux';
import store from "./redux/store/store";
import RenderRouter from './routes';
import { ConfigProvider } from 'antd';
import { BrowserRouter as Router } from 'react-router-dom';
import CommonProvider from './contexts/CommonContext';


function App() {
  return (
    <CommonProvider>
      <ConfigProvider>
        <Provider store={store}>
          <Router >
            <RenderRouter />
          </Router>
        </Provider>
      </ConfigProvider> 
      </CommonProvider>

  );
}

export default App;
